import { removeQueuedBooking } from 'actions/booking';
import { removeQueuedLead } from 'actions/iqos';
import { store } from 'store';
import {
  CreatePendingBookingAPIRequest,
  IQOSAddLeadAPIRequest,
} from 'utils/constants/network';
import { callAPI } from 'utils/network';

var draftBookings = [];
var isProcessingBookings = false;
var bookingRetryTimer = null;

var draftLeads = [];
var isProcessingLeads = false;
var leadRetryTimer = null;

export const processDraftLeads = leads => {
  draftLeads = [...leads];

  if (isProcessingLeads || draftLeads.length === 0) {
    return;
  }

  console.log('Is not busy... processing...');
  processLead(draftLeads[0]);
};

export const processLead = whichLead => {
  console.log('Processing Lead... ');

  const apiRequest = new IQOSAddLeadAPIRequest({ lead: whichLead });
  isProcessingLeads = true;

  if (leadRetryTimer !== null) {
    clearTimeout(leadRetryTimer);
  }

  callAPI(apiRequest, false, true, -1).then(
    res => {
      console.log(
        'Successfully processed lead from queue. Removing from queue and processing next if any.'
      );

      isProcessingLeads = false;
      store.dispatch(removeQueuedLead(whichLead));
    },
    err => {
      isProcessingLeads = false;

      if (err.message !== 'timeout') {
        console.log('Perma-failed to add Lead');
        isProcessingLeads = false;
        store.dispatch(removeQueuedLead(whichLead));
      } else {
        console.log('Failed to process Draft lead. Retrying in 10 seconds.');
        leadRetryTimer = setTimeout(() => {
          processLead(whichLead);
        }, 10000);
      }
    }
  );
};

export const processDraftBookings = bookings => {
  draftBookings = [...bookings];

  if (isProcessingBookings || draftBookings.length === 0) {
    return;
  }

  console.log('Is not busy... processing...');
  processBooking(draftBookings[0]);
};

const processBooking = whichBooking => {
  console.log('Processing Booking... ');

  const apiRequest = new CreatePendingBookingAPIRequest({
    booking: whichBooking,
  });
  isProcessingBookings = true;

  if (bookingRetryTimer !== null) {
    clearTimeout(bookingRetryTimer);
  }

  callAPI(apiRequest, false, true, -1).then(
    res => {
      console.log(
        'Successfully processed booking from queue. Removing from queue and processing next if any.'
      );
      isProcessingBookings = false;

      store.dispatch(removeQueuedBooking(whichBooking));
    },
    err => {
      isProcessingBookings = false;

      if (err.message !== 'timeout') {
        console.log('Perma-failed to add Booking');
        isProcessingBookings = false;
        store.dispatch(removeQueuedBooking(whichBooking));
      } else {
        console.log(
          'Failed to process Draft bookings. Retrying in 10 seconds.'
        );
        leadRetryTimer = setTimeout(() => {
          processBooking(whichBooking);
        }, 10000);
      }
    }
  );
};



// WEBPACK FOOTER //
// ./src/utils/queue/index.js